export default __webpack_public_path__ + "static/banner-ways-to-instantly-boost-your-savings-v2-58d0af5902da4b2121bdacc480ef723f.jpg";